<template>
  <div>
    <el-dialog title="充值记录" :visible.sync="dialogVisible" width="40%">
      <el-button
        size="small"
        @click="addFilterate"
        type="primary"
        v-permission="['/Custom/Custom/AddFilterate']"
        >充值过滤次数</el-button
      >
      <el-table
        :data="dataList"
        v-loading="dataListLoading"
        ref="table"
        class="custom-tbl"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          prop="TotalCount"
          label="次数"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="TotalAmount"
          label="金额"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="CreateTime"
          label="时间"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
export default {
  mixins: [viewModule],
  data() {
    return {
      dataForm: { id: "" },
      dialogVisible: false,
      mixinViewModuleOptions: {
        createdIsNeed: false,
        requestMethod: "get",
        getDataListIsPage: false,
        getDataListURL: "/api/CustomerCompany/GetRecharge",
      },
    };
  },
  methods: {
    init(id) {
      this.dialogVisible = true;
      this.dataForm.id = id;
      this.getDataList();
    },
    //充值过滤次数
    addFilterate(id) {
      this.$emit("addFilterate", this.dataForm.id)
    },
  },
};
</script>

<style>
</style>